import {Component, Input, OnInit} from '@angular/core';
import {ShopDataService} from '@webu/data';

@Component({
  selector: 'webu-days-remaining-component',
  templateUrl: './days-remaining-component.html'
})
export class DaysRemainingComponent implements OnInit{
  @Input () numberOfDaysLeft? : string;
  @Input () productType? : string;
  progress : number ;
  isExpiring = false; 
  days: string;
  left: string;

  higherDaysLeft = false;
  constructor(private shopDataService: ShopDataService){}
  
  ngOnInit(): void {
    this.setProgressBasedOnDaysRemaining();
    this.getGenericCopy();
  }

  /**
   * Set the progress of the circle based on the days remaining
   * If the trial plan is expiring soon with in 30 days, the circle will have blue with progress bar
   * If the plan is expiring with in 90 days but it's prepaid, the circle will be red circle
   * If the trial plan is expiring with in 7 days, then show red circle
   */
  setProgressBasedOnDaysRemaining(): void {
    if (this.isSevenDayTrialExpiringSoon() || this.isPrepaidExpiringSoon()) {
        this.progress = 100; // Full red circle
        this.isExpiring = true;
    } else if (this.isTrialPlan30DayExpiring()) { //Blue Circle
        this.progress = ((Number(this.numberOfDaysLeft)) / 30) * 100;
        this.isExpiring = false;
    }
    else{
      this.higherDaysLeft = true;
    }
  }

  private isTrialPlan30DayExpiring(): boolean {
   return Number(this.numberOfDaysLeft) <= 30 && this.productType === 'TRIAL';
  }

  private isPrepaidExpiringSoon(): boolean {
    return  Number(this.numberOfDaysLeft) <= 60 && this.productType === 'PREPAID';
  }

  private isSevenDayTrialExpiringSoon(): boolean {
   return Number(this.numberOfDaysLeft) <= 7 && this.productType === 'TRIAL';
  }
  
  calculateOffset(): number {
    const circumference = 2 * Math.PI * 45;
    const progressOffset = this.progress / 100 * circumference;
    return this.isExpiring ? circumference - progressOffset : circumference + progressOffset;
  }

  getGenericCopy(){
    const daysLeftCopy = this.shopDataService.getGenericCopy('myplans.daysleft');
    if(daysLeftCopy){
      const [days, left] = daysLeftCopy.split(' ');
      this.days = days;
      this.left = left;
    }
  }
}
